/** Jump history for connector jumps (pure — unit tested). */
import type { PagePoint, ViewerPosition } from './types';

export interface JumpEntry {
  /** Where the viewer was before the jump. */
  position: ViewerPosition;
  /** The pin that was tapped (pulsed on return), if any. */
  source?: PagePoint;
  at: number;
}

export class JumpStack {
  private items: JumpEntry[] = [];

  constructor(private readonly max = 20) {}

  push(entry: JumpEntry): void {
    this.items.push(entry);
    if (this.items.length > this.max) this.items.splice(0, this.items.length - this.max);
  }

  pop(): JumpEntry | undefined {
    return this.items.pop();
  }

  peek(): JumpEntry | undefined {
    return this.items[this.items.length - 1];
  }

  clear(): void {
    this.items = [];
  }

  get size(): number {
    return this.items.length;
  }
}
